// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aQp3h","title":"styles_title__1jyzs"};